"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.table = exports.warn = exports.error = exports.info = exports.log = void 0;
var constants_1 = require("./constants");
var debug = function (message, method, consoleOnly) {
    if (consoleOnly === void 0) { consoleOnly = false; }
    if (constants_1.IS_DEVELOPMENT && window.console) {
        window.console[method](message);
    }
    if (constants_1.IS_PRODUCTION && !consoleOnly) {
        // TODO: Log to Logstash/Sentry
    }
    return null;
};
var log = function (message) {
    return debug(message, "log");
};
exports.log = log;
var info = function (message) {
    return debug(message, "info");
};
exports.info = info;
var error = function (message) {
    return debug(message, "error");
};
exports.error = error;
var warn = function (message) {
    return debug(message, "warn");
};
exports.warn = warn;
var table = function (message) {
    return debug(message, "table", true);
};
exports.table = table;
//# sourceMappingURL=log.js.map